export class Admin {
	public role: string;
	public name: string;
	public email: string;
	public pcbsRole?: string;
}
export class Interview {
	public curId: string;
}



// WEBPACK FOOTER //
// ./src/common/modules/admin/models/Admin.ts